<div *ngIf="isFBSelected" (click)="closePreview()" class="app-sub-page">
  <div class="facebook">
    <div class="fb-preview-header-section">
      <div class="fb-page-image-section">
        <!--          <img src="{{ formData.images }}" alt=""/>-->
        <img src="{{userplaceholderImg}}" alt="">
      </div>
      <div class="fb-header-information">
        <p class="fb-page-name">{{ fbPage }}</p>
        <p class="fb-publish-info">
          published by <span>QuickInfo</span>[?]. {{ formatDate(startDate) }}.
          <i class="icon-globe"></i>
        </p>
      </div>
    </div>
    <div class="fb-preview-description-section">
      <p [innerHTML]="formData.title"></p>
      <p
        style="margin:10px 0"
        [innerHTML]="formData.description"></p>
      <div *ngIf="formData?.offerText" style="padding-top: 15px;border-top: 1px dashed #000"
           [innerHTML]="formData.offerText">
      </div>
    </div>
    <div class="preview-image-container fb-preview-image-section">
      <ng-container *ngIf="!isVideo">
        <img src="{{ imageArray[0].url }}" alt="" class="fb-preview-img"/>
      </ng-container>
      <ng-container *ngIf="isVideo">
        <video
          style="width: 100%"
          id="video"
          controls
          disablePictureInPicture
          playsinline
          muted
          autoplay
          name="media"
          #video
        >
          <source src="{{videoUrl}}" type="video/mp4">
        </video>
      </ng-container>
    </div>

    <div class="fb-option-section">
      <div class="fb-options">
        <ion-icon name="thumbs-up-outline"></ion-icon>
        <span>like</span>
      </div>
      <div class="fb-options">
        <ion-icon name="chatbox-outline"></ion-icon>
        <span>Comment</span>
      </div>
      <div class="fb-options">
        <ion-icon name="arrow-redo-outline"></ion-icon>
        <span>Share</span>
      </div>
    </div>
    <div (click)="closePreview()" class="closebtn">
      <ion-icon name="close-circle-outline"></ion-icon>
    </div>
  </div>
</div>
<div *ngIf="isInstaSelected" (click)="closePreview()" class="app-sub-page">
  <div class="facebook">
    <div class="fb-preview-header-section">
      <div class="fb-page-image-section">
        <!--          <img src="{{ formData.images }}" alt=""/>-->
        <img src="{{userplaceholderImg}}" alt="">
      </div>
      <div class="fb-header-information">
        <p class="fb-page-name">{{ fbPage }}</p>
      </div>
    </div>

    <div class="preview-image-container fb-preview-image-section">
      <img src="{{ imageArray[0].url }}" alt="" class="fb-preview-img"/>
    </div>


    <div class="insta-option-section">
      <div class="fb-options">
        <ion-icon name="heart-outline" class="mt-2"></ion-icon>
      </div>
      <div class="fb-options">
        <ion-icon name="chatbubble-outline"  class="mt-2"></ion-icon>
      </div>
      <div class="fb-options">
        <ion-icon name="send-outline" style="transform: rotate(-30deg);"></ion-icon>
      </div>
    </div>
    <div class="fb-preview-description-section">
      <p [innerHTML]="formData.title"></p>
      <p
        style="margin:10px 0"
        [innerHTML]="formData.description"></p>
      <div *ngIf="formData?.offerText" style="padding-top: 15px;border-top: 1px dashed #000" [innerHTML]="formData.offerText">
      </div>
    </div>
    <div (click)="closePreview()" class="closebtn">
      <ion-icon name="close-circle-outline"></ion-icon>
    </div>
  </div>

</div>
